import React from 'react';
import bowser from 'yola-bowser';
import Modal from '../modal';
import { MAX_HEIGHT, MAX_WIDTH, MOB_INTEND } from './constants/common';

function TourDialog({ children, className = '' }) {
  return (
    // @ts-ignore TS(2322): Type '{ children: ReactElement<any, string | JSXEl... Remove this comment to see the full error message
    <Modal
      centered
      containerClassName={className}
      width={MAX_WIDTH}
      height={MAX_HEIGHT}
      maxWidth={MAX_WIDTH}
      maxHeight={MAX_HEIGHT}
      fullscreen={bowser.mobile}
      fullscreenIndent={MOB_INTEND}
      overlay="visible"
      draggable={false}
      resizable={false}
    >
      {children}
    </Modal>
  );
}

export default TourDialog;
